import { useQuery } from "@tanstack/react-query";
import Attachment from "./Attachment";
import { AttachmentModel } from "../types/attachment.types";
import { Flex } from "@mantine/core";
import { requestResourceUrl } from "../lib/mts-url";
import { RequestBaseFields } from "../types/request.types";

interface AttachmentsProps {
  request: RequestBaseFields;
}

export default function RequestAttachments({ request }: AttachmentsProps) {
  const attachmentsPath = requestResourceUrl(request, 'attachments');
  const query = useQuery({
    queryKey: [attachmentsPath],
    queryFn: () => fetch(attachmentsPath).then(r => r.json())
  });
  let content;

  if (query.isPending) {
    content = 'Loading...';
  } else if (query.isSuccess) {
    const { data } = query;

    if (data.length === 0) {
      content = 'No Attachments';
    } else {
      content = (
        <>
          {data.map((a: AttachmentModel) =>
            <Attachment attachment={a} key={a.id} />
          )}
        </>
      );
    }
  }

  return (
    <Flex gap="md" wrap="wrap">
      {content}
    </Flex>
  );
}
